// PostHog wird nur nach expliziter Einwilligung des Nutzers initialisiert.
// Die Einwilligung wird im localStorage unter "fahn_cookie_consent" gespeichert.

import posthog from 'posthog-js';

const POSTHOG_KEY = 'phc_xAvL2Iq4tFmANRE7kzbKwaSqp1HJjN7x48s3vr0CMjs';
const POSTHOG_HOST = 'https://us.i.posthog.com';

let initialized = false;

export function initPostHog() {
  if (initialized) return;
  if (typeof window === 'undefined') return;

  posthog.init(POSTHOG_KEY, {
    api_host: POSTHOG_HOST,
    person_profiles: 'identified_only',
    session_recording: {
      recordCrossOriginIframes: true,
      capturePerformance: false,
    },
    autocapture: true,
    capture_pageview: true,
  });

  initialized = true;
}

/**
 * Consent-gated event capture (Regel 11). No-op until the user has opted in
 * (PostHog initialised); never throws — analytics must not break the UI.
 * Event names snake_case: whatsapp_click, viewing_request_opened,
 * viewing_request_submitted, application_opened, application_submitted,
 * home_listing_click. Props minimal (apartment_id, source).
 */
export function trackEvent(name, props = {}) {
  if (!initialized) return;
  try {
    posthog.capture(name, props);
  } catch (_) {
    // intentionally swallowed
  }
}

export function optInToTracking() {
  initPostHog();
  if (typeof window !== 'undefined') {
    localStorage.setItem('fahn_cookie_consent', 'accepted');
    localStorage.setItem('fahn_cookie_consent_date', new Date().toISOString());
  }
}

export function optOutOfTracking() {
  if (typeof window !== 'undefined') {
    localStorage.setItem('fahn_cookie_consent', 'declined');
    localStorage.setItem('fahn_cookie_consent_date', new Date().toISOString());
  }
  if (initialized && posthog.opt_out_capturing) {
    posthog.opt_out_capturing();
  }
}

export function hasConsent() {
  if (typeof window === 'undefined') return false;
  return localStorage.getItem('fahn_cookie_consent') === 'accepted';
}

export function hasMadeChoice() {
  if (typeof window === 'undefined') return false;
  return localStorage.getItem('fahn_cookie_consent') !== null;
}

export function resetConsent() {
  if (typeof window !== 'undefined') {
    localStorage.removeItem('fahn_cookie_consent');
    localStorage.removeItem('fahn_cookie_consent_date');
  }
}

// Auto-init wenn bereits Einwilligung vorhanden
if (typeof window !== 'undefined' && hasConsent()) {
  initPostHog();
}
